import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit'

import getDataApi from './api'
import { bffApi } from './api/bff'

export function createStore() {
	const dataApi = getDataApi()

	return configureStore({
		reducer: {
			[dataApi.reducerPath]: dataApi.reducer,
			[bffApi.reducerPath]: bffApi.reducer,
		},
		middleware: (getDefaultMiddleware) =>
			getDefaultMiddleware().concat(dataApi.middleware, bffApi.middleware),
	})
}

export type AppReduxStore = ReturnType<typeof createStore>
export type AppDispatch = AppReduxStore['dispatch']
export type RootState = ReturnType<AppReduxStore['getState']>
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action>
